import PageTemplate from "../../components/feature/PageTemplate";
import { aboutContent } from "../../mocks/about-content";

export default function About() {
  return <PageTemplate content={aboutContent} />;
}
